// extracted by mini-css-extract-plugin
export default {"adminLayout":"Admin_adminLayout__RFnsN","mainContent":"Admin_mainContent__tBQ6j","comingSoon":"Admin_comingSoon__mW+TH"};